var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProxy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 8,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_819)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8193 8.59137C15.9201 9.43592 13.3427 11.1347 11.4234 13.4661C9.50407 15.7974 8.33199 18.6532 8.06006 21.6607H14.9172C15.3169 17.084 16.6438 12.6367 18.8172 8.58923M14.9172 24.3392H8.06006C8.33143 27.3468 9.503 30.2028 11.4219 32.5346C13.3408 34.8663 15.918 36.5656 18.8172 37.4107C16.6438 33.3632 15.3169 28.9158 14.9172 24.3392ZM22.2543 37.9828C19.6563 33.8623 18.0634 29.1887 17.6043 24.3392H28.3936C27.9345 29.1887 26.3417 33.8623 23.7436 37.9828C23.2475 38.0075 22.7505 38.0075 22.2543 37.9828ZM27.1829 37.4085C30.0818 36.5636 32.6587 34.8647 34.5776 32.5333C36.4965 30.202 37.6683 27.3465 37.9401 24.3392H31.0829C30.6832 28.9158 29.3563 33.3632 27.1829 37.4107M31.0829 21.6628H37.9401C37.6687 18.6552 36.4971 15.7992 34.5782 13.4674C32.6593 11.1357 30.0821 9.43642 27.1829 8.59137C29.3563 12.6388 30.6832 17.0862 31.0829 21.6628ZM22.2543 8.01708C22.7512 7.99235 23.2489 7.99235 23.7458 8.01708C26.3431 12.1378 27.9352 16.8114 28.3936 21.6607H17.6065C18.0715 16.7814 19.6679 12.1035 22.2543 8.01708Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProxy);
export default __webpack_public_path__ + "static/media/proxy.35add44dfc479585d253ce8f3ad22a45.svg";
export { ForwardRef as ReactComponent };